import { __decorate } from "tslib";
import { BaseModule, Module } from "@fastoche/core";
import { TrackingEventRegistry } from "./TrackingEventRegistry";
import { TrackingEventDispatcher } from "./TrackingEventDispatcher";
import { CommonTrackingEvents } from "../model/CommonTrackingEvents";
import { NavigationTracker } from "./NavigationTracker";
let CoreTrackingModule = class CoreTrackingModule extends BaseModule {
    registerServices(container, config) {
        container.bind(TrackingEventRegistry).toSelf().inSingletonScope();
        container.bind(TrackingEventDispatcher).toSelf().inSingletonScope();
        if (config.trackNavigation) {
            container.bind(NavigationTracker).toSelf().inSingletonScope();
        }
    }
    configureServices(container, config) {
        const registry = container.get(TrackingEventRegistry);
        registry.registerEvents(CommonTrackingEvents)
            .registerEvents(config.events);
        const dispatcher = container.get(TrackingEventDispatcher);
        for (const handler of config.handlers) {
            dispatcher.registerHandler(typeof handler === "function" ? container.resolve(handler) : handler);
        }
    }
    applicationReady(hook) {
        const { rootContainer } = hook.applicationContext;
        if (rootContainer.isBound(NavigationTracker)) {
            const navigationTracker = rootContainer.get(NavigationTracker);
            navigationTracker.startTracking();
        }
    }
};
CoreTrackingModule = __decorate([
    Module()
], CoreTrackingModule);
export { CoreTrackingModule };
//# sourceMappingURL=index.js.map